import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import { GetReportListReq, GetReportListResp, Filter } from './types'

export const getReportListAction = createAsyncAction(
  'admin/report/monthly/GET_LIST_REQ',
  'admin/report/monthly/GET_LIST_RESP',
  'admin/report/monthly/GET_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()

export const updateFilter = createStandardAction(
  'admin/report/monthly/UPDATE_FILTER_ACTION'
)<Filter, void>()

export const clearFilter = createStandardAction(
  'admin/report/monthly/CLEAR_FILTER_ACTION'
)<void>()

export const exportReportListAction = createAsyncAction(
  'admin/report/monthly/EXPORT_LIST_REQ',
  'admin/report/monthly/EXPORT_LIST_RESP',
  'admin/report/monthly/EXPORT_LIST_FAIL'
)<GetReportListReq, GetReportListResp, any>()
